import React, { useId } from 'react'

interface GiftIconProps {
  className?: string
}

export const GiftIcon: React.FC<GiftIconProps> = ({ className }) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id}`
  const paint1Id = `paint1_linear_${id}`
  const paint2Id = `paint2_linear_${id}`

  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <path
        d="M12.02 3.49C10.62 2.25 9.22 1 7.35 1C6.05 1 5 2.12 5 3.5C5 4.88 6.05 6 7.35 6C8.94 6 10.48 4.75 12.02 3.49ZM12.02 3.49L12.02 3.49M12.02 3.49L12.05 3.52M12.02 3.49C12.03 3.50 12.04 3.51 12.05 3.52M12.02 3.49C12.02 3.49 12.02 3.49 12.02 3.49M12.02 3.49C13.55 2.24 15.08 1 16.65 1C17.95 1 19 2.12 19 3.5C19 4.88 17.95 6 16.65 6C14.82 6 13.44 4.76 12.05 3.52"
        stroke={`url(#${paint0Id})`}
      />
      <path
        d="M4 19L12 23L20 19V11L12 7L4 11V19Z"
        stroke={`url(#${paint1Id})`}
      />
      <path d="M4 11L12 15L20 11" stroke={`url(#${paint2Id})`} />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="19"
          y1="3.5"
          x2="5"
          y2="3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#4F4F4F" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="12"
          y1="21"
          x2="12"
          y2="7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" />
          <stop offset="0.65" stopColor="#C0C0C0" />
          <stop offset="0.76" stopColor="#C0C0C0" />
          <stop offset="1" stopColor="#4F4F4F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={paint2Id}
          x1="19"
          y1="13"
          x2="4"
          y2="13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.18" stopColor="#4F4F4F" stopOpacity="0.87" />
          <stop offset="0.65" stopColor="#C0C0C0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
